import { Property } from '@model';
import { useQuickView } from '@providers';

const redirectApiBaseUrl = import.meta.env.VITE_REDIRECT_API_BASE_URL;

export const useShareProperty = () => {
  const { showQuickViewModal } = useQuickView();

  const shareProperty = async (property: Property) => {
    if (!navigator.share) {
      showQuickViewModal(property); // TODO: Show modal with share options
      return;
    }

    navigator
      .share({
        title: `${property.subCategory}, ${property.area}`,
        url: `${redirectApiBaseUrl}/${property.id}`,
      })
      .catch(console.error);
  };

  return { shareProperty };
};
